var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-block btn-primary disabled"},[_vm._v(" "+_vm._s(_vm.$t('allerts.loading'))+" "),_c('span',{staticClass:"loading-s1 sm-j"},[_vm._v(".")]),_c('span',{staticClass:"loading-s2 sm-j"},[_vm._v(".")]),_c('span',{staticClass:"loading-s3 sm-j"},[_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }